module.exports = __webpack_public_path__ + "img/delete.a2c1b470.svg";